import { LOCALE_EN } from "@growtherapy/i18n";
import telehealthCoreEn from "./en/telehealth-core.json";
import { SeedlingsCoreResources } from "@grow-therapy-team/seedling-components";
import { SproutCoreResources } from "@growtherapy/sprout-ui";

export const NS_TELEHEALTH_CORE = "telehealth-core";

const telehealthCoreResouces = {
  [NS_TELEHEALTH_CORE]: telehealthCoreEn,
  ...SeedlingsCoreResources,
  ...SproutCoreResources,
};

export const telehealthCoreResoucesEn = {
  [LOCALE_EN]: telehealthCoreResouces,
};
